import { IonButton, IonButtons, IonContent, IonIcon, IonLabel, IonPage } from "@ionic/react";
import { arrowBackOutline } from "ionicons/icons";
import { Trans, useTranslation } from "react-i18next";
import { useTheme } from "react-jss";
import { useHistory } from "react-router";
import Header from "../../../components/header/header";
import { AboutIOSContainerStyle } from "./containerStyle.jss";
import ios_example from "../../../assets/image/ios/iphone_example.png";

export const AboutIOSContainer = () => {
    const { t } = useTranslation("common");
    const theme = useTheme();
    const style = AboutIOSContainerStyle({ theme });
    const history = useHistory();

    return (
        <IonPage>
            <Header
                element={
                    <IonButtons slot="start">
                        <IonButton
                            routerDirection="back"
                            onClick={() => history.goBack()}
                        >
                            <IonIcon
                                slot="icon-only"
                                icon={arrowBackOutline}
                                size={"large"}
                                className={style.icon}
                            />
                        </IonButton>
                    </IonButtons>
                }
                title={t("PAGE.ABOUT_IOS.TITLE")}
                showLogout={false}
            />
            <IonContent className="ion-padding">
                <div className={style.container}>
                    <IonLabel className={style.sectionTitle}>{t("PAGE.ABOUT_IOS.CONTENT_TITLE")}</IonLabel>
                    <Trans
                        t={t}
                        i18nKey={"PAGE.ABOUT_IOS.CONTENT"}
                    />
                    <img
                        src={ios_example}
                        width={300}
                    />
                </div>
            </IonContent>
        </IonPage>
    );
};
